export const KeysOfResourceLocationForLanguage = [
    'name',
    'address',
    'businessHours',
];
